(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hf-buendel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var wurzel = document.querySelector('.hf-bdl');
    if (!wurzel) return;

    var rabatt = parseFloat(wurzel.getAttribute('data-rabatt')) || 0;
    var abMenge = parseInt(wurzel.getAttribute('data-ab'), 10) || 2;
    var freiAb = (parseFloat(wurzel.getAttribute('data-frei')) || 0) * 100;

    var knoepfe = Array.prototype.slice.call(wurzel.querySelectorAll('.hf-bdl__wahl'));
    var leiste = wurzel.querySelector('.hf-bdl__leiste');
    var stand = wurzel.querySelector('.hf-bdl__stand');
    var kauf = wurzel.querySelector('.hf-bdl__kauf');
    var fehler = wurzel.querySelector('.hf-bdl__fehler');
    if (!knoepfe.length || !leiste) return;

    var gewaehlt = function () {
      return knoepfe.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; });
    };

    var rechnen = function () {
      var w = gewaehlt();
      if (!w.length) { leiste.hidden = true; kauf.disabled = true; stand.innerHTML = ''; return; }
      if (typeof window.hfGeld !== 'function') return;
      var geld = window.hfGeld;

      var voll = w.reduce(function (s, b) { return s + parseInt(b.getAttribute('data-preis'), 10); }, 0);
      var greift = w.length >= abMenge;
      var endpreis = greift ? Math.round(voll * (100 - rabatt) / 100) : voll;

      var text = '<b>' + w.length + (w.length === 1 ? ' Präparat' : ' Präparate') + '</b> · ';
      if (greift) {
        text += '<em>−' + rabatt + ' %</em> ' + geld(endpreis) + ' <s>' + geld(voll) + '</s>';
      } else {
        text += geld(voll) + ' · noch ' + (abMenge - w.length) + ' Artikel bis −' + rabatt + ' %';
      }
      if (freiAb > 0) {
        text += endpreis >= freiAb ? ' · versandfrei' : ' · noch ' + geld(freiAb - endpreis) + ' bis versandfrei';
      }

      stand.innerHTML = text;
      leiste.hidden = false;
      kauf.disabled = false;
    };

    knoepfe.forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        b.setAttribute('aria-pressed', b.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        rechnen();
      });
    });

    kauf.addEventListener('click', function () {
      var w = gewaehlt();
      if (!w.length) return;
      kauf.disabled = true;
      if (fehler) fehler.hidden = true;

      var korb = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var last = { items: w.map(function (b) { return { id: Number(b.getAttribute('data-id')), quantity: 1 }; }) };
      if (korb && korb.getSectionsToRender) {
        last.sections = korb.getSectionsToRender().map(function (s) { return s.id; });
        last.sections_url = window.location.pathname;
      }
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify(last)
      })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d.status) throw new Error(d.description || d.message);
          knoepfe.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
          rechnen();
          if (korb && korb.renderContents) korb.renderContents(d);
          else window.location.href = root + 'cart';
        })
        .catch(function (e) {
          kauf.disabled = false;
          if (fehler) { fehler.hidden = false; fehler.textContent = e.message || 'Das hat nicht geklappt. Bitte erneut versuchen.'; }
        });
    });

    rechnen();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hf-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.hf-coll').forEach(function (root) {
      var knoepfe = root.querySelectorAll('[data-hf-ansicht]');
      if (!knoepfe.length) return;
      root.classList.add('is-live');

      var setzen = function (wahl) {
        root.setAttribute('data-ansicht', wahl);
        knoepfe.forEach(function (b) {
          var an = b.getAttribute('data-hf-ansicht') === wahl;
          b.classList.toggle('is-on', an);
          b.setAttribute('aria-pressed', an ? 'true' : 'false');
        });
      };

      try {
        var gemerkt = localStorage.getItem('hf-ansicht');
        if (gemerkt) setzen(gemerkt);
      } catch (e) { /* privater Modus — dann eben Raster */ }

      knoepfe.forEach(function (b) {
        b.addEventListener('click', function () {
          var wahl = b.getAttribute('data-hf-ansicht');
          setzen(wahl);
          try { localStorage.setItem('hf-ansicht', wahl); } catch (e) {}
        });
      });

      var auswahl = root.querySelector('.hf-coll__sort select');
      if (auswahl) auswahl.addEventListener('change', function () { auswahl.form.submit(); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hf-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.hf-faq').forEach(function (root) {
      var reiter = root.querySelectorAll('[data-hf-faq]');
      if (!reiter.length) return;

      var fragen = Array.prototype.slice.call(root.querySelectorAll('.hf-frage'));
      var leer = root.querySelector('.hf-faq__leer');

      root.classList.add('is-live');

      reiter.forEach(function (pille) {
        pille.addEventListener('click', function () {
          var wahl = pille.getAttribute('data-hf-faq');
          reiter.forEach(function (p) {
            var an = p === pille;
            p.classList.toggle('is-on', an);
            p.setAttribute('aria-pressed', an ? 'true' : 'false');
          });
          var sichtbar = 0;
          fragen.forEach(function (f) {
            var passt = wahl === 'alle' || f.getAttribute('data-hf-gruppe') === wahl;
            f.hidden = !passt;
            if (!passt) f.open = false;
            if (passt) sichtbar++;
          });
          if (leer) leer.hidden = sichtbar > 0;
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hf-mega"]) return;
  try {
    
  (function () {
    var wurzel = document.querySelector('.hf-mega');
    if (!wurzel) return;
    var panel = wurzel.querySelector('.hf-mega__panel');
    var name = (wurzel.getAttribute('data-anker') || '').trim().toLowerCase();
    if (!name) return;

    var ziel = null;
    document.querySelectorAll('.header__inline-menu a, .header__inline-menu summary').forEach(function (el) {
      if (el.textContent.replace(/\s+/g, ' ').trim().toLowerCase() === name) ziel = el;
    });
    /* Kein Anker gefunden: Sektion bleibt versteckt. */
    if (!ziel) return;

    wurzel.hidden = false;
    ziel.setAttribute('aria-haspopup', 'true');
    ziel.setAttribute('aria-expanded', 'false');
    ziel.setAttribute('aria-controls', panel.id);

    var timer;
    var auf = function () {
      window.clearTimeout(timer);
      wurzel.classList.add('is-offen');
      ziel.setAttribute('aria-expanded', 'true');
    };
    var zu = function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        wurzel.classList.remove('is-offen');
        ziel.setAttribute('aria-expanded', 'false');
      }, 160);
    };

    ziel.addEventListener('mouseenter', auf);
    ziel.addEventListener('focus', auf);
    ziel.addEventListener('mouseleave', zu);
    ziel.addEventListener('blur', zu);
    panel.addEventListener('mouseenter', auf);
    panel.addEventListener('mouseleave', zu);
    panel.addEventListener('focusin', auf);
    panel.addEventListener('focusout', zu);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && wurzel.classList.contains('is-offen')) {
        wurzel.classList.remove('is-offen');
        ziel.setAttribute('aria-expanded', 'false');
        ziel.focus();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hf-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var pop = document.querySelector('.hf-popup');
    if (!pop) return;

    var schluessel = 'hf-popup-zu';
    var tage = parseInt(pop.getAttribute('data-tage'), 10) || 30;
    try {
      var bis = parseInt(localStorage.getItem(schluessel), 10);
      if (bis && bis > Date.now()) return;
    } catch (e) { /* privater Modus */ }

    var vorher = null;

    var zu = function () {
      pop.classList.remove('is-da');
      window.setTimeout(function () { pop.hidden = true; }, 240);
      document.documentElement.style.overflow = '';
      try { localStorage.setItem(schluessel, String(Date.now() + tage * 86400000)); } catch (e) {}
      if (vorher && vorher.focus) vorher.focus();
    };

    var auf = function () {
      vorher = document.activeElement;
      pop.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      window.requestAnimationFrame(function () { pop.classList.add('is-da'); });
      var feld = pop.querySelector('input[type="email"]');
      if (feld) feld.focus();
    };

    pop.querySelectorAll('[data-hf-popup-zu]').forEach(function (b) { b.addEventListener('click', zu); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) zu(); });

    window.setTimeout(auf, (parseInt(pop.getAttribute('data-start'), 10) || 12) * 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hf-premium-index"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.hf-index').forEach(function (root) {
      var img = root.querySelector('.hf-index__img');
      var cap = root.querySelector('[data-hf-caption]');
      var link = root.querySelector('[data-hf-link]');
      var pvPrice = root.querySelector('[data-hf-pv-price]');
      var pvDay = root.querySelector('[data-hf-pv-day]');
      var rows = Array.prototype.slice.call(root.querySelectorAll('[data-hf-index-row]'));
      var leer = root.querySelector('.hf-index__empty');

      rows.forEach(function (row) {
        var src = row.getAttribute('data-hf-src');
        var show = function () {
          if (!img || !src || img.getAttribute('src') === src) return;
          img.setAttribute('src', src);
          if (cap) cap.textContent = row.getAttribute('data-hf-alt') || '';
          if (link) link.setAttribute('href', row.getAttribute('data-hf-url') || '#');
          if (pvPrice) pvPrice.textContent = row.getAttribute('data-hf-price') || '';
          if (pvDay) pvDay.textContent = row.getAttribute('data-hf-day') || '';
        };
        row.addEventListener('mouseenter', show);
        row.addEventListener('focusin', show);
      });

      root.querySelectorAll('[data-hf-filter]').forEach(function (pill) {
        pill.addEventListener('click', function () {
          var wahl = pill.getAttribute('data-hf-filter');
          root.querySelectorAll('[data-hf-filter]').forEach(function (p) {
            var an = p === pill;
            p.classList.toggle('is-on', an);
            p.setAttribute('aria-pressed', an ? 'true' : 'false');
          });
          var sichtbar = 0;
          rows.forEach(function (row) {
            var passt = wahl === 'alle' || row.getAttribute('data-hf-group') === wahl;
            row.hidden = !passt;
            if (passt) sichtbar++;
          });
          if (leer) leer.hidden = sichtbar > 0;
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hf-schnellansicht"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var huelle = document.querySelector('.hf-schnell');
    if (!huelle) return;
    var ziel = huelle.querySelector('.hf-schnell__ziel');
    var vorher = null;

    var zu = function () {
      huelle.classList.remove('is-da');
      window.setTimeout(function () { huelle.hidden = true; ziel.innerHTML = ''; }, 240);
      document.documentElement.style.overflow = '';
      if (vorher && vorher.focus) vorher.focus();
    };

    huelle.querySelectorAll('[data-hf-schnell-zu]').forEach(function (b) { b.addEventListener('click', zu); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !huelle.hidden) zu(); });

    document.addEventListener('click', function (e) {
      var knopf = e.target.closest('[data-hf-schnell]');
      if (!knopf) return;
      e.preventDefault();
      vorher = knopf;
      var url = knopf.getAttribute('data-hf-schnell');

      ziel.innerHTML = '';
      huelle.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      window.requestAnimationFrame(function () { huelle.classList.add('is-da'); });

      fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'view=quickadd')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          ziel.innerHTML = html;
          var erste = ziel.querySelector('button, a, input');
          if (erste) erste.focus();
        })
        .catch(function () { window.location.href = url; });
    });

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-hf-schnell-form]');
      if (!form) return;
      e.preventDefault();

      var knopf = form.querySelector('button');
      var meldung = huelle.querySelector('.hf-schnell__fehler');
      knopf.disabled = true;

      var korb = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var last = {
        items: [{ id: Number(form.querySelector('[name="id"]').value), quantity: Number(form.querySelector('[name="quantity"]').value) || 1 }]
      };
      if (korb && korb.getSectionsToRender) {
        last.sections = korb.getSectionsToRender().map(function (s) { return s.id; });
        last.sections_url = window.location.pathname;
      }
      var wurzel = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      fetch(wurzel + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify(last)
      })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d.status) throw new Error(d.description || d.message);
          zu();
          if (korb && korb.renderContents) korb.renderContents(d);
          else window.location.href = wurzel + 'cart';
        })
        .catch(function (err) {
          knopf.disabled = false;
          if (meldung) { meldung.hidden = false; meldung.textContent = err.message || 'Das hat nicht geklappt. Bitte erneut versuchen.'; }
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hf-toast"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var karte = document.querySelector('.hf-toast');
    if (!karte) return;

    try {
      if (sessionStorage.getItem('hf-toast-zu') === '1') return;
    } catch (e) { /* privater Modus — dann eben zeigen */ }

    var quelle = karte.querySelector('.hf-toast__quelle');
    var saetze = Array.prototype.slice.call(quelle.content.querySelectorAll('.hf-toast__satz'));
    if (!saetze.length) return;

    var ziel = karte.querySelector('.hf-toast__inhalt');
    var start = parseInt(karte.getAttribute('data-start'), 10) || 6;
    var takt = parseInt(karte.getAttribute('data-takt'), 10) || 12;
    var i = 0;
    var uhr;

    var zeigen = function () {
      ziel.innerHTML = '';
      ziel.appendChild(saetze[i % saetze.length].cloneNode(true));
      i++;
      karte.hidden = false;
      window.requestAnimationFrame(function () { karte.classList.add('is-da'); });
      window.setTimeout(function () { karte.classList.remove('is-da'); }, takt * 1000 - 600);
    };

    var schliessen = function () {
      window.clearInterval(uhr);
      karte.classList.remove('is-da');
      window.setTimeout(function () { karte.hidden = true; }, 240);
      try { sessionStorage.setItem('hf-toast-zu', '1'); } catch (e) {}
    };

    karte.querySelector('.hf-toast__zu').addEventListener('click', schliessen);

    window.setTimeout(function () {
      zeigen();
      if (saetze.length > 1) uhr = window.setInterval(zeigen, takt * 1000);
    }, start * 1000);
  })();

  } catch(e) { console.error(e); }
})();
})();
